import React from 'react';
import './styles.scss';

export const View = (): JSX.Element => (
    <div className="is-password-temporary-alert">
        Ваш профиль был создан с использованием интерфейса внешней системы.<br />
         В целях безопасности настоятельно рекомендуется изменить пароль.
    </div>
);
